import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as OpenedEyeIcon } from '../../assets/svg/openedEye.svg';
import { ReactComponent as ClosedEyeIcon } from '../../assets/svg/closedEye.svg';
import { ReactComponent as MoneyIcon } from '../Header/money_icon.svg';
import { StoreType } from '../../store/spirs/types';
import { toggleBalanceVisibility } from '../../spirsApi/api-client';
import { PlayerIdShowBalance } from '../../models/api/codegen/code';
import { convertBalanceView } from './balanceUtils';

export const ShowBalance: React.FC = () => {
    const {
        spirs: { playerInfo, playerToken: sessiontoken }
    } = useSelector((state: StoreType) => state);
    const { t } = useTranslation();

    const [showBalance, setShowBalance] = useState<boolean>(
        !!playerInfo.showBalance
    );

    useEffect(() => {
        setShowBalance(!!playerInfo.showBalance);
    }, [playerInfo]);

    const handleToggleBalanceVisibility = () => {
        setShowBalance(prevState => !prevState);
        toggleBalanceVisibility({
            showBalance: !showBalance,
            sessiontoken
        }).then((res: PlayerIdShowBalance | any) => {
            setShowBalance(res?.showBalance);
        });
    };

    if (playerInfo.playerId === 'GUEST') {
        return null;
    }

    return (
        <div className="flex justify-between tablet:p-4 tablet:h-[44px] desktop:h-[48px] select-none items-center mt-[16px]">
            <div className="max-tablet:hidden text-[#C6C7C9] tablet:text-[15px] desktop:text-[19px]">
                {t('verticalMenuItems.balance.title')}
            </div>
            <MoneyIcon className="w-[18px] h-[18px] mr-2 tablet:hidden" />
            <div className="flex items-center mobile:gap-[7px] tablet:gap-[10px] desktop:gap-[12px]">
                <div className="font-bold text-[#FFFFFF] max-tablet:text-[10px]">
                    {showBalance
                        ? !playerInfo.balance
                            ? '0,00'
                            : convertBalanceView(
                                  playerInfo.balance,
                                  playerInfo.currencyScale
                              )
                        : '•••••'}
                </div>
                <div
                    className="flex items-center gap-3 h-full cursor-pointer"
                    title={
                        showBalance
                            ? t('verticalMenuItems.balance.hideBalance')
                            : t('verticalMenuItems.balance.showBalance')
                    }
                    onClick={handleToggleBalanceVisibility}
                >
                    {showBalance ? <OpenedEyeIcon /> : <ClosedEyeIcon />}
                </div>
            </div>
        </div>
    );
};
